// extracted by mini-css-extract-plugin
export default {"tile":"dgonrZ1SU_xppbGvSeAs"};